<template>
  <v-text-field
    v-bind="$attrs"
    :value="prevInput"
    autocomplete="nope"
    v-on="inputListeners" />
</template>
<script>

function formatIban(ibanString) {
    // 1. uppercase and remove invalid chars
   ibanString = ibanString.slice(0,2).toUpperCase().replace(/[^0-9A-Z]/g, "") + ibanString.slice(2).replace(/[^0-9]/g, "");
    // 2. group in blocks by 4
    ibanString = ibanString.length ? ibanString.match(/.{1,4}/g).join(" ") : ""; 
    return ibanString;
}

export default {
  name: "IbanField",
  props: {
    'value': {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prevInput: this.value ? this.value : ""
    };
  },
  computed: {
    inputListeners: function () {
      const vm = this;
      return Object.assign({},
        this.$listeners,
        {
          input: function (data) {
            let input = vm.$children[0].$refs.input;



            const formatedIban = formatIban(data);
            const newCursor = input.selectionEnd;
            const lengthChange = data.length - vm.prevInput.length;
            //console.log( "lengthChange", lengthChange );

            /*reset binding data for input field and update it in $nextTick
              => if formatting removed the input, value doesn't change => DOM update is not triggered */
            vm.prevInput = ' ';
            // communicate formatted input to parent component (v-model)
            vm.$emit('input', formatedIban);
            vm.$nextTick(() => {
              //ontick to set the value another to correct cursor position after autocompletion
              vm.prevInput = formatedIban;
              vm.$nextTick(() => {
                if(lengthChange > 0) {
                  const blankFix = (newCursor % 5 == 0 ) ?  1 : 0;
                  input.setSelectionRange(newCursor + blankFix, newCursor + blankFix);
                } else if(lengthChange < 0) {
                  input.setSelectionRange(newCursor, newCursor);
                }
              });
            });
          },
          keydown: function (event) {
            let input = vm.$children[0].$refs.input;
            const keyPressed = event.key;
            const newCursor = input.selectionEnd;
            if(keyPressed === 'Delete' && input.selectionEnd === input.selectionStart && newCursor % 5 == 4 ){
              vm.$nextTick(() => {
                input.setSelectionRange(newCursor + 1, newCursor + 1);
              });
            } else if(keyPressed === 'Backspace' && input.selectionEnd === input.selectionStart && newCursor && newCursor % 5 == 0 ){
              vm.$nextTick(() => {
                input.setSelectionRange(newCursor - 1, newCursor - 1);
              });
            }
          },
          blur: function (event) {
            const formatedIban = formatIban(event.srcElement.value);
            vm.prevInput = formatedIban;
            // communicate formatted input to parent component (v-model)
            vm.$emit('input', formatedIban);
          }
        }
      );
    }
  }
};
</script>
<style>

</style>
